export default (axios) => ({
  // CRUD functions
  list(payload) {
    return axios.get('v1/sublines', { params: payload })
  }
})
